import {Component, Input, OnInit} from '@angular/core';
import {InteractionService} from '../../Services/interaction.service';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css']
})
export class LoadingSpinnerComponent implements OnInit {

  loadingTrigger:boolean = true;
  constructor(private interactionService:InteractionService) { }

  ngOnInit(): void {
    this.interactionService.loadingSpinnerTrigger.subscribe(
        (value) =>{
          console.log('Trigger called ...');
          this.loadingTrigger = value;
        }
    );
  }

}
